/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable react/prop-types */
import React from "react";
import { Grid, Button, Divider } from "@mui/material";
import { useStyles } from "./termSheet.style";

import DownloadIcon from "./assets/Shape.svg";

const TermSheetFooterButtonsContainer = (props) => {
  const {
    permissionsToRenderInUI,
    termSheetConfig,
    termSheetAction,
    termSheetData,
    isDownloadingTermSheet,
    isTermsheetAlreadySaved,
    isDataEdited
  } = props;
  const { showFooterActions } = permissionsToRenderInUI;
  const classes = useStyles();

  return (
    <Grid className={classes.footerContainer}>
      {termSheetAction !== "download" && <Divider />}

      {termSheetAction !== "download" &&
      !isDownloadingTermSheet &&
      showFooterActions &&
      !termSheetConfig?.isViewMode ? (
        <Grid
          container
          justifyContent='space-between'
          spacing={2}
          sx={{ margin: "12px 0px" }}
        >
          <Grid container justifyContent='flex-start' xs={9}>
            <Grid item style={{ paddingLeft: "0px" }}>
              <Button
                size='large'
                variant='text'
                onClick={() => {
                  return termSheetConfig?.footer?.onCloseModal(false);
                }}
              >
                Close
              </Button>
            </Grid>
            <Grid item style={{ paddingLeft: "0px" }}>
              <Button
                size='large'
                variant='outlined'
                onClick={() => {
                  return termSheetConfig?.footer?.onSaveTermSheet(
                    { ...termSheetData },
                    isTermsheetAlreadySaved
                  );
                }}
              >
                Save
              </Button>
            </Grid>
            <Grid item sx={{ marginLeft: "12px" }}>
              <Button
                size='large'
                variant='contained'
                onClick={() => {
                  return termSheetConfig?.footer?.onSendEmail(
                    { ...termSheetData },
                    isTermsheetAlreadySaved
                  );
                }}
              >
                Send
              </Button>
            </Grid>
          </Grid>
          <Grid
            xs={3}
            container
            justifyContent='flex-end'
            sx={{ paddingRight: "12px" }}
          >
            <Button
              size='large'
              variant='text'
              onClick={() => {
                return termSheetConfig?.footer?.handleDownloadPDF(
                  isDataEdited,
                  isTermsheetAlreadySaved
                );
              }}
            >
              Download &ensp;
              <img src={DownloadIcon} alt='download-icon' />
            </Button>
          </Grid>
        </Grid>
      ) : null}

      {termSheetAction === "view-from-list" && !isDownloadingTermSheet ? (
        <Grid container spacing={2} sx={{ margin: "12px 0px" }}>
          <Grid container justifyContent='space-between'>
            <Button
              size='large'
              variant='outlined'
              onClick={() => {
                return termSheetConfig?.footer?.onCloseModal(false);
              }}
            >
              Close
            </Button>
            <Button
              size='large'
              variant='text'
              onClick={() => {
                return termSheetConfig?.footer?.handleDownloadPDF({ ...termSheetData });
              }}
            >
              Download &ensp;
              <img src={DownloadIcon} alt='download-icon' />
            </Button>
          </Grid>
        </Grid>
      ) : null}
    </Grid>
  );
};

export default React.memo(TermSheetFooterButtonsContainer);
